import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const ProtectedRoute = (props) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  // localStorage.clear();

  const userToken = JSON.parse(localStorage.getItem("auth"));
  console.log("token", userToken);
  const CheckUserToken = () => {
    if (!userToken || userToken === "undefined") {
      setIsLoggedIn(false);
      return navigate("/auth");
    }
    setIsLoggedIn(true);
  };
  useEffect(() => {
    CheckUserToken();
  }, [isLoggedIn]);

  console.log("En ligne ? ", isLoggedIn);
  return <React.Fragment>{isLoggedIn ? <Outlet /> : null}</React.Fragment>;
};
export default ProtectedRoute;
